import { Component, OnInit } from '@angular/core';
import {
  FormBuilderService,
  ApplicationService,
  NotificationService,
  WorkbookService,
  CommunicationService,
  SalesService, TypesService,
} from '../../services/index';
import { WizardFormComponent, WizardSteps } from './wizard-form.component';
import { BaseSubmissionModel } from '../../models/submission/base-submission-model';
import { FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { SubmissionService } from '../../services/submission.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router, ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrokerNotesComponent } from '../widgets/broker-notes/broker-notes.component';
import { ProductComponent } from '../widgets/product/product.component';
import { RateComponent } from '../widgets/rate/rate.component';
import { SolicitorBorrowerDetailsComponent } from '../widgets/solicitor-borrower-details/solicitor-borrower-details.component';
import { SolicitorPanelDetailsComponent } from '../widgets/solicitor-panel-details/solicitor-panel-details.component';
import { SecurityDetailsComponent } from '../widgets/security-details/security-details.component';
import { HomeLoanDetailsComponent } from '../widgets/home-loan-details/home-loan-details.component';
import { ApplicationTypeComponent } from '../widgets/application-type/application-type.component';
import { LoanDetailsTermsComponent } from '../widgets/loan-details-terms/loan-details-terms.component';
import { QuotesListComponent } from '../widgets/quotes-list/quotes-list.component';
import { QuoteDetailsComponent } from '../widgets/quote-details/quote-details.component';
import { ConfirmationComponent } from '../widgets/confirmation/confirmation.component';
import { SubmitComponent } from '../widgets/submit/submit.component';
import { DocumentUploadComponent } from '../widgets/documents-upload/documents-upload.component';
import { AutoCollateralComponent } from '../widgets/auto-collateral/auto-collateral.component';
import { ExpensesDetailsComponent } from '../widgets/expense-details/expenses-details.component';
import { LiabilitiesDetailsComponent } from '../widgets/liabilities-details/liabilities-details.component';
import { AssetsDetailsComponent } from '../widgets/assets-details/assets-details.component';
import { IncomeDetailsComponent } from '../widgets/income-details/income-details.component';
import { InvestmentIncomeComponent } from '../widgets/investment-income/investment-income.component';
import { EmploymentDetailsComponent } from '../widgets/employment-details/employment-details.component';
import { BalloonAmountComponent } from '../widgets/balloon-amount/balloon-amount.component';
import { LoanTermsComponent } from '../widgets/loan-terms/loan-terms.component';
import { SingleSplitLoanAmountComponent } from '../widgets/single-split-loan-amount/single-split-loan-amount.component';
import { LoanDetailsComponent } from '../widgets/loan-details/loan-details.component';
import { BusinessCarLoanDetailsComponent } from '../widgets/business-car-loan-details/business-car-loan-details.component';
import { PersonalDetailsComponent } from '../widgets/personal-details/personal-details.component';
import { CompanyDetailsComponent } from '../widgets/company-details/company-details.component';
import { TrustDetailsComponent } from '../widgets/trust-details/trust-details.component';
import { BorrowerTypeEnhancedComponent } from '../widgets/borrower-type-enhanced/borrower-type-enhanced.component';
import { BorrowerTypeComponent } from '../widgets/borrower-type/borrower-type.component';
import { AbnAcnComponent } from '../widgets/abn-acn/abn-acn.component';
import { CustomerDetailsComponent } from '../widgets/customer-details/customer-details.component';
import { OriginatorBrokerComponent } from '../widgets/originator-broker/originator-broker.component';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import {DataHandlerService} from '../../services/data-handler.service';

@Component({
    selector: 'app-broker-quotes',
    templateUrl: './wizard-form.component.html',
    styles: [],
    standalone: true,
    imports: [MatSidenavModule, NgClass, MatProgressBarModule, NgIf, MatListModule, NgFor, MatButtonModule,
      FormsModule, OriginatorBrokerComponent, ReactiveFormsModule, CustomerDetailsComponent, AbnAcnComponent, BorrowerTypeComponent,
      BorrowerTypeEnhancedComponent, TrustDetailsComponent, CompanyDetailsComponent, PersonalDetailsComponent, BusinessCarLoanDetailsComponent,
      LoanDetailsComponent, SingleSplitLoanAmountComponent, LoanTermsComponent, BalloonAmountComponent, EmploymentDetailsComponent,
      InvestmentIncomeComponent, IncomeDetailsComponent, AssetsDetailsComponent, LiabilitiesDetailsComponent, ExpensesDetailsComponent,
      AutoCollateralComponent, DocumentUploadComponent, SubmitComponent, ConfirmationComponent, QuoteDetailsComponent, QuotesListComponent,
      LoanDetailsTermsComponent, ApplicationTypeComponent, HomeLoanDetailsComponent, SecurityDetailsComponent, SolicitorPanelDetailsComponent,
      SolicitorBorrowerDetailsComponent, RateComponent, ProductComponent, BrokerNotesComponent, MatProgressSpinnerModule, MatProgressSpinnerModule]
})
export class BrokerQuotesComponent extends WizardFormComponent implements OnInit {

  public loanPurposeType = 'motor-vehicle-loan'; // TODO FIX THIS FOR CAR LOAN

  constructor(public formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              public submissionService: SubmissionService,
              public applicationService: ApplicationService,
              public notificationService: NotificationService,
              public sanitizer: DomSanitizer,
              public oauthService: OAuthService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public workbookService: WorkbookService,
              public typesService: TypesService,
              public communicationService: CommunicationService,
              public salesService: SalesService) {

    super(formBuilderService, dataHandlerService, submissionService, applicationService, notificationService, sanitizer, oauthService,
      router, activatedRoute, workbookService, typesService, communicationService, salesService);
    console.log('Init My Quotes');
  }

  public steps: WizardSteps[] = [{
    icon: 'arrow_forward',
    name: 'My Quotes',
    widgets: [
      { name: 'app-originator-broker', class: 'col-sm-12'},
      { name: 'app-quotes-list', class: 'col-sm-12'},
    ],
    classNameStatus: 'default'
  }];
}
